import { enableProdMode } from '@angular/core';
import { environment } from '@env/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { APP_CONFIG } from './app/app.config';

if (environment.env === 'pre' || environment.env === 'prod') {
  enableProdMode();
}

bootstrapApplication(AppComponent, APP_CONFIG);
